import React from 'react'
import BlackModalBg from './BlackModalBg';
import winImg from "../../../assets/Game/chartbtn/victory.png"
import loseImg from "../../../assets/Game/chartbtn/defrost.png"
import classes from "./EndGameComponent.module.css"


interface endGameProps {
  win: boolean
  playAgainBtn: () => void
}

const EndGameComponent:React.FC<endGameProps> = ({win, playAgainBtn}) => {
  let endImg = loseImg;
  switch (win) {
    case true:
      endImg = winImg
      break;
    case false:
      endImg = loseImg
      break;
  
    default:
      endImg = loseImg
      break;
  }
  return (
      <BlackModalBg>
      <div className={classes["end-game-root"]}>
        <img
          data-aos="slide-down"
          data-aos-easing="ease-out"
          data-aos-duration="500"
          className={classes["end-game-img"]}
          src={endImg}
          alt='Win or Lose'
        />
        <button
          data-aos="flip-left"
          data-aos-easing="ease-out"
          id={classes["modal-btn"]}
          onClick={playAgainBtn}>Play Again</button>
      </div>
      </BlackModalBg>
  )
}

export default EndGameComponent